import { useEffect } from "react";
import { applySeo, type SeoOptions } from "@/utils/seo";

/**
 * Applies per-page TDK (title / description / keywords) for the SPA.
 */
export function useSeo(options: SeoOptions) {
  const { title, description, keywords } = options;
  useEffect(() => {
    applySeo({ title, description, keywords });
  }, [title, description, keywords]);
}

export default useSeo;